import ReportFolder from 'modules/reports/models/ReportFolder'
import ListEndpoint from 'modules/reports/orm/endpoints/ListEndpoint'

type ListReportFoldersRequest = {
  accountId: number
}

class ListReportFoldersEndpoint extends ListEndpoint<ListReportFoldersRequest, ReportFolder> {
  model = ReportFolder
  urlParams = ['accountId']

  buildPath(request: ListReportFoldersRequest) {
    return `accounts/${request.accountId}/report_folders`
  }
}

export default new ListReportFoldersEndpoint().fetch
